import { DeviceStatus } from '../../models/device-status';
import { ConfirmationDialogField } from './confirmation-dialog.component';

export function createDeviceStatusConfirmationDetails(
  labelTranslationKeyPrefix: string,
  statusTranslationKeyPrefix: string,
  currentStatus: DeviceStatus,
  newStatus: DeviceStatus,
  lastLocationLabel: string,
  lastLocation?: string | null,
): ConfirmationDialogField[] {
  return [
    {
      label: `${labelTranslationKeyPrefix}.currentStatus`,
      translateLabel: true,
      value: `${statusTranslationKeyPrefix}.${currentStatus}`,
      translateValue: true,
      renderValueAsHtml: false,
    },
    {
      label: `${labelTranslationKeyPrefix}.newStatus`,
      translateLabel: true,
      value: `${statusTranslationKeyPrefix}.${newStatus}`,
      translateValue: true,
      renderValueAsHtml: false,
    },
    {
      label: lastLocationLabel,
      translateLabel: true,
      value: lastLocation || '-',
      translateValue: false,
      renderValueAsHtml: false,
    },
  ];
}
